import axios from "axios";

const instance = axios.create({
  baseURL: process.env.VUE_APP_SERVER_SIDE_URL,
});

let isRefreshing = false;
let refreshPromise = null;

export function decodePayload(token) {
  try {
    const base64Url = token.split(".")[1];
    const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split("")
        .map((c) => "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2))
        .join("")
    );
    return JSON.parse(jsonPayload);
  } catch (e) {
    console.error("Error decoding token:", e);
    return null;
  }
}

function almostExpire(exp, graceMs = 300000) {
  if (!exp) return false;
  const currentTime = Date.now();
  const expirationTime = parseInt(exp);
  if (currentTime >= expirationTime) {
    return true;
  }
  return currentTime >= expirationTime - graceMs;
}

instance.interceptors.request.use(
  async (config) => {
    const token = localStorage.getItem("token");
    const exp = localStorage.getItem("exp");
    if (config.url?.includes("login") || config.url?.startsWith("/public/")) {
      return config;
    }
    if (token && exp) {
      if (almostExpire(exp)) {
        if (isRefreshing && refreshPromise) {
          try {
            const newToken = await refreshPromise;
            config.headers.Authorization = `Bearer ${newToken}`;
            return config;
          } catch (error) {
            return Promise.reject(error);
          }
        }
        isRefreshing = true;
        refreshPromise = (async () => {
          try {
            const response = await axios.post(
              `${process.env.VUE_APP_SERVER_SIDE_URL}/user/refresh-token`,
              { token },
              {
                headers: {
                  Authorization: `Bearer ${token}`,
                },
              }
            );
            const newToken = response.data.token;
            localStorage.setItem("token", newToken);
            const newPayload = decodePayload(newToken);
            if (newPayload && newPayload.exp) {
              localStorage.setItem("exp", (newPayload.exp * 1000).toString());
            }

            return newToken;
          } catch (error) {
            console.error("refresh failed", error);
            const route = window.location.pathname;
            if (!route.startsWith("/public/") && !route.startsWith("/auth/")) {
              localStorage.clear();
              window.location.href = "/auth/login";
            }
            throw error;
          } finally {
            isRefreshing = false;
            refreshPromise = null;
          }
        })();
        try {
          const newToken = await refreshPromise;
          config.headers.Authorization = `Bearer ${newToken}`;
        } catch (error) {
          return Promise.reject(error);
        }
      } else {
        config.headers.Authorization = `Bearer ${token}`;
      }
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

instance.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;

      const route = window.location.pathname;
      if (!route.startsWith("/public/") && !route.startsWith("/auth/")) {
        localStorage.clear();
        window.location.href = "/auth/login";
      }
    }

    return Promise.reject(error);
  }
);

export default instance;
